import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domClass from 'dojo/dom-class';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import FilterPanel from '../../../moreCore/UI/FilterPanel/FilterPanel';
import CateringBookingForm from './CateringBookingForm';
// template-instantiated child widget (data-dojo-type in CateringBookingHome.html) — kept as a
// side-effect import so the AMD loader still preloads it (not referenced as a value in code).
import "./CateringBookingTable";
import template from './CateringBookingHome.html?raw';
// NOTE (JS2TS): dropped dead deps (imported in the original define() but unused in code &
// template): dojo/_base/connect, dojo/_base/array, dojo/_base/Color, dojo/keys,
// dijit/_WidgetBase, dijit/_TemplatedMixin, dijit/_WidgetsInTemplateMixin, dijit/registry,
// dojo/dom-attr, dojo/dom-style, dojo/dom-construct, dojo/mouse.

class CateringBookingHome extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    filterpanels: any = [];
    _isFilterResultLoaded = false;
    _currentFilterSettingsApplied: any = false;
    _currentFilterSettings: any = null;
    _timeout: any = null;

    _maxResultCount = 200;
    _currentStartIndex = 0;

    loadFilterOptions() {
        this.StandbyStart();
        var url = window.appRoot + "CateringBooking/GetFilterOptions";

        this.RequestManager.post(
            url,
            {
                jsonData: null
            },
            lang.hitch(this, this._onLoadFilterOptionsResponse),
            lang.hitch(this, this._onLoadFilterOptionsError),
            false // sync
        );
    }

    _onLoadFilterOptionsResponse(response: any) {
        this.StandbyStop();

        var filteropt = response.filterPanelRoot;

        this.prepareFilteroptions(filteropt);

        this.prepareTablelayout(response.tableLayouts[0]);

        domClass.remove(this.filterSection, "w3-hide");
    }

    _onLoadFilterOptionsError(error: any) {

        this.StandbyStop();

        this.showErrorDetailsDlg(error.Message, null, null, "ok", null);

        //alert("Filteroptionen können nicht geladen werden: " + error.Message);
    }

    prepareTablelayout(layout: any) {
        if (this.table) {
            this.table.layout = layout;
        }
    }

    prepareFilteroptions(data: any) {
        if (this.filterPanelContainer) {
            this.UiModder.domConstruct.empty(this.filterPanelContainer);
        }
        else {
            alert("this.filterPanelContainer not defined");
            return;
        }
        this.UiModder.domConstruct.empty(this.filterPanelContainer);
        var fp = new FilterPanel();
        this.filterpanel = fp;
        fp.placeAt(this.filterPanelContainer);
        fp.outputFormat = (window as any).FilterPanelFormat.compact; // JS2TS: FilterPanelFormat is referenced as a bare global in the original (not in define deps) — preserved as a leaked-global read. // das Format lassen wir jetzt mal fix. data.format == "compact" ? "compact" : "default";
        for (var i = 0; i < data.sections.length; i++) {
            var sectionData = data.sections[i];
            fp.addSection(sectionData);
        }
        on(this.filterpanel, "serializedData", lang.hitch(this, this.checkDirtyState_delayed));
        this.filterpanel.serializeData();
        // falls man noch was ergänzen möchte (readonly z.B.)
        //this.filterOptions_additionalConfig();
    }


    showErrorDetailsDlg(message: any, header: any, subtitle: any, buttons: any, callback: any) {
        let dlg = new GenericDialog();

        if (!header) {
            header = this.translations["CateringBooking_Filter"];
        }

        dlg.show(message, header, subtitle, null, buttons, callback);
    }

    checkDirtyState_delayed(result: any) {

        // bestehendes Event unterbrechen
        if (this._timeout != null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        this._timeout = setTimeout(lang.hitch(this, this.checkDirtyState, result), 100);
    }

    checkDirtyState(bForceFalse: any) {
        if (bForceFalse === false) {
            this.isDirty = false;
            return;
        }
        var json = this.filterpanel.getData();//{ sections: this.filterpanel.getData() };
        var bValid = json !== null;
        this._currentFilterSettings = json;

        if (this._currentFilterSettingsApplied != JSON.stringify(this._currentFilterSettings) && bValid === true) {
            this.isDirty = true;
            domClass.remove(this.btnSubmit, "w3-disabled");
        } else {
            this.isDirty = false;
            domClass.add(this.btnSubmit, "w3-disabled");
        }
    }

    _onClick_Submit(evt: any) {
        //this.getAndSubmitFilter();

        this._currentFilterSettingsApplied = JSON.stringify(this._currentFilterSettings);
        domClass.add(this.btnSubmit, "w3-disabled");
        this.getFilterData()
    }

    getAndSubmitFilter() {
        if (this._isRequestActive === true || (this.isDirty != true)) {

            return;
        }

        // irgendwie erzwingen, dass alle Steuerelemente ihren jetzt aktuellen Wert hergeben!
        for (let fp of this.filterpanels) {
            fp.serializeData();
        }

        domClass.add(this.filterSection, "w3-disabled");

        this._isFilterResultLoaded = false;

        this.getFilterData();
    }

    getFilterData() {
        //if (this.table) {
        //    this.StandbyStart(this.table);
        //}
        var url = window.appRoot + "CateringBooking/GetBookingList";
        this._isRequestActive = true;
        let data = null;

        data = this._currentFilterSettings;

        data.limit = this._maxResultCount;
        data.currentStartIndex = this._currentStartIndex;

        var stringData = JSON.stringify(data);


        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onGetFilterDataResponse, this._currentFilterSettings),
            lang.hitch(this, this._onGetAxisDescriptorsError), // JS2TS: _onGetAxisDescriptorsError is never defined in the original (latent bug) — preserved verbatim (resolves to any via the index signature).
            false // sync
        );
    }

    _onGetFilterDataResponse(currentFiltersettings: any, response: any) {
        this.StandbyStop();
        domClass.remove(this.filterSection, "w3-disabled");
        this._isRequestActive = false;
        this._currentFilterSettingsApplied = currentFiltersettings;
        //this.checkDirtyState();

        this.table.setData(response);

        domClass.remove(this.tableSection, "w3-hide");
    }

    _onGetFilterDataError(error: any) {
        this.showErrorDetailsDlg(error.Message, this.translations["CateringBooking_Filter"], null, "ok", null);
        this.StandbyStop();
        domClass.remove(this.filterSection, "w3-disabled");
    }

    //_onClick_Entity: function (entityID) {
    //    console.debug("_onClick_Entity", entityID);

    //    // TODO: open catering form...
    //    //lang.hitch(this, this.showBookingForm, entityID);

    //    this.showBookingForm(entityID);
    //},

    _onClick_NewCateringBooking() {

        this.showBookingForm();
    }

    showBookingForm(entityID?: any) {
        let dlg = new GenericDialog();
        let form = new CateringBookingForm();

        form._loadCateringPackagesList();

        dlg.hideSubtitleNode(true);
        dlg._setTopCloseBtnAttr(true);
        dlg._setHeaderAttr(this.translations["CateringBooking_FormHeader"]);
        dlg.set("closeOnEnter", false);

        on(form, "CloseCateringForm", lang.hitch(dlg, dlg.close));

        on(form, "RefreshCateringForm", () => {
            dlg.close();
            this.showBookingForm();
        });

        //form._loadCateringPackagesList();

        if (entityID) {
            //form.loadCateringBooking(entityID);
            //form._setReadonlyAttr(true);
            on(form, "CateringPackagesReady", () => {
                form.loadCateringBooking(entityID);
                form._setReadonlyAttr(true);
            });
        } else {
            domClass.remove(form.cateringBookingTemplateContainer, "w3-hide");
            domClass.remove(form.cateringSaveAsTemplateContainer, "w3-hide");
        }

        form.getDefaultUserDataValues();

        dlg.addNodeToContent(form.domNode);

        dlg.show();
    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse

    }
    postCreate() {
        super.postCreate.apply(this, arguments as any);

    }

    startup() {
        super.startup.apply(this, arguments as any);

        this._isLoadedFirstFilter = false;

        var title = this.translations["CateringBooking__MainTitle"];
        if (title == "" || title == null || typeof (title) == "undefined") {
            title = "ekus Webtool";
        }
        document.title = title;

        this.loadFilterOptions();

        on(this.table, "rowclick", lang.hitch(this.showBookingForm));

    }
    destroy() {
        super.destroy.apply(this, arguments as any);
    }
}
CateringBookingHome.prototype.declaredClass = 'WidgetCollection.JDM.CateringBooking.CateringBookingHome';

export default mdsWidget(CateringBookingHome);
